import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1.5),
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    },
    label: {
      fontSize: theme.typography.pxToRem(11),
      fontWeight: 600,
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(0.75),
    },
    entry: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.75),
      fontSize: theme.typography.pxToRem(11),
      lineHeight: 1.6,
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      flexShrink: 0,
    },
    name: {
      color: theme.palette.text.secondary,
    },
    value: {
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  }),
  { name: 'ChartTooltip' }
);
